import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { optimizeImageUrlFillSquare } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { TransparencyOverlay } from "@faire/web--source/ui/TransparencyOverlay";
import { ISearchRequestReferrer } from "@faire/web-api--source/indigofair/data/ISearchRequestReferrer";
import React from "react";
import styled, { css } from "styled-components";
import { Context } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Context";
import { TrackedLink } from "@faire/retailer/components/TrackedLink";
import { EAEAEA_PIXEL } from "@faire/retailer/consts/EAEAEA_PIXEL";
import { PAGE_TYPE } from "@faire/retailer/consts/PAGE_TYPE";
import { localizedUrlWithQueryParams } from "@faire/retailer/lib/pathUtils";
import { FiniteCarouselBase } from "./FiniteCarouselBase";
var IMAGE_DIMENSION = 88;
export var SearchTiles = function() {
    var _React_useContext = React.useContext(Context), layoutElement = _React_useContext.layoutElement, onItemClick = _React_useContext.onItemClick, requestId = _React_useContext.requestId, pageType = _React_useContext.pageType;
    var isSSR = useIsSSR();
    var renderItem = function(item, index) {
        var isHero = !!layoutElement.background_color;
        var imageUrl = item.image ? optimizeImageUrlFillSquare(item.image, isSSR, IMAGE_DIMENSION, {
            ignoreResizeTag: true
        }) : EAEAEA_PIXEL;
        var _item_cta_link;
        var tileLink = (_item_cta_link = item.cta_link) !== null && _item_cta_link !== void 0 ? _item_cta_link : "/";
        var link = pageType === PAGE_TYPE.HOMEPAGE ? localizedUrlWithQueryParams(tileLink, {
            refType: ISearchRequestReferrer.SearchRequestReferrerType.HOMEPAGE_RECOMMENDED_SEARCHES,
            refReqId: requestId
        }) : tileLink;
        var _item_query;
        return /*#__PURE__*/ _jsxs(SearchTile, {
            to: link,
            token: (_item_query = item.query) !== null && _item_query !== void 0 ? _item_query : "",
            onClick: function() {
                if (layoutElement.on_click_event_name) {
                    onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(layoutElement.on_click_event_name, requestId, "");
                }
            },
            children: [
                /*#__PURE__*/ _jsxs(ImageContainer, {
                    $withShadow: isHero,
                    children: [
                        /*#__PURE__*/ _jsx(TransparencyOverlay, {}),
                        /*#__PURE__*/ _jsx("img", {
                            src: imageUrl,
                            alt: item.query
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "1x"
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    color: layoutElement.main_text_color,
                    align: "center",
                    children: item.query
                })
            ]
        }, index);
    };
    var getItems = function() {
        return layoutElement.layout_element_data.map(function(elementData) {
            return elementData.search_query_tile;
        }).filter(isNotUndefined);
    };
    return /*#__PURE__*/ _jsx(FiniteCarouselBase, {
        renderItem: renderItem,
        items: getItems()
    });
};
var SearchTile = styled(TrackedLink).withConfig({
    componentId: "sc-b69063ab-0"
})([
    "display:flex;flex-direction:column;align-items:center;margin-right:",
    ";",
    "{width:",
    "px;margin-right:",
    ";}"
], getSpacing("2x"), responsiveMediaQueries.desktopAndAbove, IMAGE_DIMENSION, getSpacing("4x"));
var ImageContainer = styled.div.withConfig({
    componentId: "sc-b69063ab-1"
})([
    "position:relative;background-color:",
    ";border-radius:50%;width:",
    "px;height:",
    "px;overflow:hidden;",
    " img{display:block;width:100%;height:100%;}"
], Core.surface.inverse, IMAGE_DIMENSION, IMAGE_DIMENSION, function(props) {
    return props.$withShadow ? css([
        "border:1px solid ",
        ";box-shadow:0px 4px 8px 0px rgba(0,0,0,0.12);"
    ], Core.border.subdued) : css([
        "border:1px solid ",
        ";"
    ], Core.border.muted);
});
